module.exports = __webpack_public_path__ + "static/img/baoxiu.498c615.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/baoxiu.png
// module id = EOC5
// module chunks = 0